module.exports = __webpack_public_path__ + "img/1-2.60b56207.png";